// Permissions d'un sous-gérant — utilisées uniquement pour adapter
// l'interface (masquer des sections), pas comme barrière de sécurité
// Firestore (voir firestore.rules — un sous-gérant a le même accès de
// base que son gérant principal, par simplicité).
export const PERMISSIONS_DEFAUT = {
  voirReservations: true,
  confirmerReservations: true,
  ajouterLocataires: true,
  voirPaiements: true,
  modifierChambres: false,
  voirCommissions: false,
  supprimerDonnees: false,
};

export const PERMISSIONS_LABELS = {
  voirReservations: 'Voir les réservations',
  confirmerReservations: 'Confirmer les réservations',
  ajouterLocataires: 'Gérer les locataires',
  voirPaiements: 'Voir les paiements',
  modifierChambres: 'Modifier les chambres',
  voirCommissions: 'Voir les commissions',
  supprimerDonnees: 'Supprimer des données',
};

// true pour un gérant "principal" (toutes permissions) ; sinon les
// permissions réelles du sous-gérant (avec valeurs par défaut si absentes).
export function permissionsEffectives(userProfile) {
  if (userProfile?.role !== 'sous-gerant') {
    return { voirReservations: true, confirmerReservations: true, ajouterLocataires: true, voirPaiements: true, modifierChambres: true, voirCommissions: true, supprimerDonnees: true };
  }
  return { ...PERMISSIONS_DEFAUT, ...(userProfile.permissions || {}) };
}
